import { useDispatch } from "react-redux";

import {
  getListData,
  clearListState,
  payloadAgentsList,
  //getBrandsListData,
  getWalletsData,
  clearWalletsState,
  //createWalletsData,
  getDescendantAgentsData,
  clearDescendantAgentsState,
  payloadDescendantAgents,
  getAgentRolesData,
  clearAgentRolesState,
  getWalletIdentitiesData,
  clearWalletIdentitiesState,
  payloadWalletIdentities,
  createAgentData,
  clearCreateAgentState,
  getDetailsListData,
  clearDetailsState,
  enableWalletData,
  clearEnableWalletState,
  disableWalletData,
  clearDisableWalletState,
  addWalletsData,
  clearAddWalletState,
  getAgentBalanceByIdData,
  clearAgentBalanceState,
  createPlayerData,
  clearCreatePlayerState,
  getPlayerListData,
  clearPlayerListState,
  getPlayerBalanceByIdData,
  clearPlayerBalanceState,
  getPlayerListDetailsData,
  clearPlayerListDetailsState,
  payloadPlayersList,
  transferToAgentData,
  clearTransferToAgentState,
  clearPlayersOptionsState,
  clearPlayerWalletIdentitiesState,
  clearTransferToPlayerState,
  getPlayersOptionsData,
  getPlayerWalletIdentitiesData,
  transferToPlayerData,
  payloadPlayersOptions,
  payloadPlayerWalletIdentities,
  getPlayerProfileData,
  clearPlayerProfileState,
  payloadPlayerProfile,
  updatePlayerProfileData,
  clearUpdatePlayerProfileState,
  payloadUpdatePlayerProfile,
  payloadAgentProfile,
  payloadUpdateAgentProfile,
  updateAgentProfileData,
  clearUpdateAgentProfileState,
  clearAgentProfileState,
  getAgentProfileData,
  clearAgentRoleState,
  updateAgentRoleData,
  payloadUpdateAgentRole,
  getFilterRolesData,
  toggleBlockAgentData,
  clearToggleBlockAgentState,
  getBetListFiltersData,
  getCasinoBetListFiltersData,
  setAgentNewPasswordData,
  clearAgentNewPasswordState,
  toggleBlockPlayerData,
  clearToggleBlockPlayerState,
  getPlayerStatusData,
  clearPlayerStatusState,
  setPlayerNewPasswordData,
  clearPlayerNewPasswordState,
  getToDescendantAgentsData,
  clearToDescendantAgentsState,
} from "./index";


export const useAgents = () => {
  const dispatch = useDispatch();

  const getList = (data: payloadAgentsList) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());
  const getDetails = (data: payloadAgentsList) => dispatch(getDetailsListData(data));
  const clearDetails = () => dispatch(clearDetailsState());
  //const getBrandsList = (data: any) => dispatch(getBrandsListData(data));
  //const clearBrandsList = () => dispatch(clearBrandsListState());

  const getWallets = () => dispatch(getWalletsData());
  const clearWallets = () => dispatch(clearWalletsState());

  const getDescendantAgents = (data: payloadDescendantAgents) => dispatch(getDescendantAgentsData(data));
  const clearDescendantAgents = () => dispatch(clearDescendantAgentsState());

  const getToDescendantAgents = (data: payloadDescendantAgents) => dispatch(getToDescendantAgentsData(data));
  const clearToDescendantAgents = () => dispatch(clearToDescendantAgentsState());

  const getAgentRoles = () => dispatch(getAgentRolesData());
  const clearAgentRoles = () => dispatch(clearAgentRolesState());

  const getWalletIdentities = (data: payloadWalletIdentities)=> dispatch(getWalletIdentitiesData(data));
  const clearWalletIdentities = () => dispatch(clearWalletIdentitiesState());

  const createAgent = (data: any)=> dispatch(createAgentData(data));
  const clearCreateAgent = () => dispatch(clearCreateAgentState());

  const enableWallet = (data: any)=> dispatch(enableWalletData(data));
  const clearEnableWallet = () => dispatch(clearEnableWalletState());

  const disableWallet = (data: any)=> dispatch(disableWalletData(data));
  const clearDisableWallet = () => dispatch(clearDisableWalletState());

  const addWallets = (data: any)=> dispatch(addWalletsData(data));
  const clearAddWallet = () => dispatch(clearAddWalletState());

  const getAgentBalanceById = (data: any)=> dispatch(getAgentBalanceByIdData(data));
  const clearAgentBalance = () => dispatch(clearAgentBalanceState());

  const createPlayer = (data: any)=> dispatch(createPlayerData(data));
  const clearCreatePlayer = () => dispatch(clearCreatePlayerState());

  const getPlayerList = (data: payloadPlayersList) => dispatch(getPlayerListData(data));
  const clearPlayerList = () => dispatch(clearPlayerListState());

  const getPlayerBalanceById = (data: any)=> dispatch(getPlayerBalanceByIdData(data));
  const clearPlayerBalance = () => dispatch(clearPlayerBalanceState());

  const getPlayerListDetails = (data: payloadPlayersList) => dispatch(getPlayerListDetailsData(data));
  const clearPlayerListDetails = () => dispatch(clearPlayerListDetailsState());

  const transferToAgent = (data: any) => dispatch(transferToAgentData(data));
  const clearTransferToAgent = () => dispatch(clearTransferToAgentState());

  const getPlayersOptions = (data: payloadPlayersOptions) => dispatch(getPlayersOptionsData(data));
  const clearPlayersOptions = () => dispatch(clearPlayersOptionsState());

  const getPlayerWalletIdentities = (data: payloadPlayerWalletIdentities)=> dispatch(getPlayerWalletIdentitiesData(data));
  const clearPlayerWalletIdentities = () => dispatch(clearPlayerWalletIdentitiesState());

  const transferToPlayer = (data: any) => dispatch(transferToPlayerData(data));
  const clearTransferToPlayer = () => dispatch(clearTransferToPlayerState());

  const getPlayerProfile = (data: payloadPlayerProfile) => dispatch(getPlayerProfileData(data));
  const clearPlayerProfile = () => dispatch(clearPlayerProfileState());

  const updatePlayerProfile = (data: payloadUpdatePlayerProfile) => dispatch(updatePlayerProfileData(data));
  const clearUpdatePlayerProfile = () => dispatch(clearUpdatePlayerProfileState());

  const getAgentProfile = (data: payloadAgentProfile) => dispatch(getAgentProfileData(data));
  const clearAgentProfile = () => dispatch(clearAgentProfileState());

  const updateAgentProfile = (data: payloadUpdateAgentProfile) => dispatch(updateAgentProfileData(data));
  const clearUpdateAgentProfile = () => dispatch(clearUpdateAgentProfileState());

  const updateAgentRole = (data: payloadUpdateAgentRole) => dispatch(updateAgentRoleData(data));
  const clearUpdateAgentRole = () => dispatch(clearAgentRoleState());

  const getFilterRoles = () => dispatch(getFilterRolesData());

  const toggleBlockAgent = (data:any) => dispatch(toggleBlockAgentData(data));
  const clearToggleBlockAgent = () => dispatch(clearToggleBlockAgentState());

  const getBetListFilters = () => dispatch(getBetListFiltersData());
  const getCasinoBetListFilters = () => dispatch(getCasinoBetListFiltersData());

  const setAgentNewPassword = (data: any) => dispatch(setAgentNewPasswordData(data));
  const clearAgentNewPassword = () => dispatch(clearAgentNewPasswordState());

  const toggleBlockPlayer = (data:any) => dispatch(toggleBlockPlayerData(data));
  const clearToggleBlockPlayer = () => dispatch(clearToggleBlockPlayerState());

  const getPlayerStatus = (data:any) => dispatch(getPlayerStatusData(data));
  const clearPlayerStatus = () => dispatch(clearPlayerStatusState());

  const setPlayerNewPassword = (data: any) => dispatch(setPlayerNewPasswordData(data));
  const clearPlayerNewPassword = () => dispatch(clearPlayerNewPasswordState());

  return {
    getList,
    clearList,
    //getBrandsList,
    //clearBrandsList,
    getWallets,
    clearWallets,
    getDescendantAgents,
    clearDescendantAgents,
    getAgentRoles,
    clearAgentRoles,
    getWalletIdentities,
    clearWalletIdentities,
    createAgent,
    clearCreateAgent,
    getDetails,
    clearDetails,
    enableWallet,
    clearEnableWallet,
    disableWallet,
    clearDisableWallet,
    addWallets,
    clearAddWallet,
    getAgentBalanceById,
    clearAgentBalance,
    createPlayer,
    clearCreatePlayer,
    getPlayerList,
    clearPlayerList,
    getPlayerBalanceById,
    clearPlayerBalance,
    getPlayerListDetails,
    clearPlayerListDetails,
    transferToAgent,
    clearTransferToAgent,
    getPlayersOptions,
    clearPlayersOptions,
    getPlayerWalletIdentities,
    clearPlayerWalletIdentities,
    transferToPlayer,
    clearTransferToPlayer,
    getPlayerProfile,
    clearPlayerProfile,
    updatePlayerProfile,
    clearUpdatePlayerProfile,
    getAgentProfile,
    clearAgentProfile,
    updateAgentProfile,
    clearUpdateAgentProfile,
    updateAgentRole,
    clearUpdateAgentRole,
    getFilterRoles,
    toggleBlockAgent,
    clearToggleBlockAgent,
    getBetListFilters,
    getCasinoBetListFilters,
    setAgentNewPassword,
    clearAgentNewPassword,
    toggleBlockPlayer,
    clearToggleBlockPlayer,
    getPlayerStatus,
    clearPlayerStatus,
    setPlayerNewPassword,
    clearPlayerNewPassword,
    getToDescendantAgents,
    clearToDescendantAgents
  }
}
